import type { AppLanguage } from "./dico";

/** Public website copy, shared by React and the widget demonstration. */
export const showcaseEnglish: Record<string, string> = {
  "Feuille de match, essais et classement des athlètes":
    "Group sheet, attempts and athlete rankings",
  "Organisation des groupes et suivi de la compétition":
    "Group organisation and competition management",
  "Répartition des groupes et horaires par plateau":
    "Groups and schedules by platform",
  "Composition des affichages et des overlays": "Display and overlay design",
  "Paramètres de la discipline et du planning":
    "Discipline and scheduling settings",
  "Configurer la discipline": "Configure your discipline",
  "Créer les affichages": "Create your displays",
  "Inscriptions et planning": "Registration and scheduling",
  "Gérer et suivre la compétition": "Manage and follow the competition",
  "Diffuser en direct": "Broadcast live",
  "Aller au contenu": "Skip to content",
  "Meet Manager, accueil": "Meet Manager, home",
  "Navigation principale": "Main navigation",
  Accueil: "Home",
  "Application web": "Web app",
  Contact: "Contact",
  "Mon espace": "My account",
  "Demander une démo": "Request a demo",
  "Fermer le menu": "Close menu",
  "Ouvrir le menu": "Open menu",
  "Solution de gestion": "Competition management",
  "de compétition": "software",
  "Gérez vos compétitions, de leur préparation à la diffusion des résultats. Centralisez les inscriptions, le planning, l’arbitrage et bien plus encore.":
    "Manage your competitions, from preparation to publishing results. Bring together registration, scheduling, refereeing and much more.",
  "Configurez les disciplines, les règles et les affichages selon votre sport et votre format de compétition, avec notre accompagnement.":
    "With our support, configure disciplines, rules and displays to suit your sport and competition format.",
  "Pour les ligues, les clubs et les organisateurs.":
    "For federations, clubs and organisers.",
  "Aperçus de l’application": "App previews",
  Groupe: "Group",
  Compétition: "Competition",
  Planning: "Schedule",
  "Les captures et l’animation illustrent une configuration de force athlétique avec des données de démonstration.":
    "The screenshots and animations show a powerlifting configuration with demo data.",
  "Les étapes de votre compétition": "Your competition, step by step",
  "Configurez votre discipline avec nous": "Configure your discipline with us",
  "Nous vous accompagnons pour adapter Meet Manager à votre format de compétition, à partir d’une discipline existante ou d’une configuration personnalisée.":
    "We help you adapt Meet Manager to your competition format, starting from an existing discipline or a custom configuration.",
  "Définissez les champs et les informations à suivre.":
    "Define the fields and information to track.",
  "Configurez les règles et les comportements de la discipline.":
    "Configure your discipline’s rules and behaviours.",
  "Vérifiez ensemble le déroulement avant la compétition.":
    "Review the workflow together before the competition.",
  "Personnalisez vos affichages": "Customise your displays",
  "Modifiez la disposition, les polices et les couleurs. Choisissez les données à afficher et les réactions aux événements de la compétition.":
    "Adjust layouts, fonts and colours. Choose the data to display and how your displays respond to competition events.",
  "Dans cette démonstration, l’événement « Barre réussie » déclenche une animation et un changement de couleur. Les événements dépendent de la discipline configurée.":
    "In this demo, the “Good lift” event triggers an animation and a colour change. Available events depend on the configured discipline.",
  "Voir l’éditeur complet": "View the full editor",
  "Préparez les inscriptions et le planning":
    "Prepare registration and scheduling",
  "Créez vos groupes, visualisez et ajustez votre planning et prévoyez le déroulement de votre compétition dans le module de planification.":
    "Create your groups, view and adjust your schedule, and plan your competition’s workflow in the scheduling module.",
  "Gérez les inscriptions et les informations des participants.":
    "Manage registration and participant information.",
  "Constituez les groupes et répartissez-les sur les espaces de compétition.":
    "Create groups and assign them to competition areas.",
  "Planifiez les épreuves et les étapes de préparation propres à votre discipline.":
    "Schedule events and the preparation stages for your discipline.",
  "Gérez et suivez la compétition": "Manage and follow the competition",
  "Retrouvez les participants, les performances et les résultats dans une interface adaptée à votre discipline.":
    "Keep participants, performances and results together in an interface tailored to your discipline.",
  "Suivez les informations et les contrôles prévus par votre règlement.":
    "Track the information and checks required by your rules.",
  "Saisissez les performances et les décisions des officiels.":
    "Enter performances and officials’ decisions.",
  "Automatisez l’arbitrage via la saisie mobile des arbitres.":
    "Automate refereeing with mobile input from your referees.",
  "Consultez et exportez les résultats dans le format de votre choix.":
    "View and export results in your preferred format.",
  "Diffusez en direct": "Broadcast live",
  "Utilisez les affichages préparés pour les écrans de la salle et les overlays de votre diffusion vidéo.":
    "Use your prepared displays on venue screens and as overlays for your video stream.",
  "Affichez les résultats en direct sur le web comme sur des écrans en salle.":
    "Display live results online and on venue screens.",
  "Intégrez vos widgets à votre stream.": "Add your widgets to your stream.",
  "Publiez les classements pour le public.":
    "Publish rankings for your audience.",
  "Consulter les compétitions": "Browse competitions",
  "Aperçu de diffusion": "Broadcast preview",
  Démonstration: "Demo",
  "Plateau 1 · Soulevé de terre": "Platform 1 · Deadlift",
  "France · -83 kg · Essai 02": "France · -83 kg · Attempt 02",
  "Essai réussi": "Good lift",
  "Trois décisions favorables": "Three good lift decisions",
  "Un affichage à vos couleurs, connecté à la compétition.":
    "A display in your colours, connected to the competition.",
  "Nos clients": "Our clients",
  "Ligue de Force Hauts-de-France": "Hauts-de-France Strength League",
  "Ligue Sud de Force": "Southern Strength League",
  "KDKS, Association Suisse de Force Athlétique":
    "KDKS, Swiss Powerlifting Association",
  Services: "Services",
  "Support technique": "Technical support",
  "Un accompagnement en français pour utiliser l’application et préparer vos compétitions.":
    "French-speaking support to help you use the app and prepare your competitions.",
  Formation: "Training",
  "Un guide d’utilisation et des formations pour les équipes d’organisation.":
    "A user guide and training for organising teams.",
  Sauvegarde: "Backups",
  "Des sauvegardes de vos compétitions accessibles depuis votre espace en ligne.":
    "Competition backups available from your online account.",
  "Mises à jour": "Updates",
  "Des améliorations régulières pour faire évoluer vos outils.":
    "Regular improvements to keep your tools evolving.",
  Personnalisation: "Customisation",
  "Fonctionnalités, exports et affichages : étudions les adaptations dont vous avez besoin.":
    "Features, exports and displays: let’s discuss the adaptations you need.",
  "Questions fréquentes": "Frequently asked questions",
  "Faut-il un compte pour consulter les résultats ?":
    "Do I need an account to view results?",
  "Les compétitions publiées en accès public peuvent être consultées sans compte. Les outils d’organisation et les espaces réservés nécessitent une connexion.":
    "Public competitions can be viewed without an account. Organising tools and restricted areas require you to sign in.",
  "Les résultats sont-ils consultables sur téléphone ?":
    "Can I view results on my phone?",
  "Oui. L’application web permet de consulter les compétitions, les essais et les classements depuis un téléphone, une tablette ou un ordinateur.":
    "Yes. The web app lets you view competitions, attempts and rankings on a phone, tablet or computer.",
  "Comment sont mis à jour les résultats ?": "How are results updated?",
  "Ils sont transmis depuis la compétition par l’équipe d’organisation. Leur disponibilité dépend de la publication et de la connexion de l’événement.":
    "The organising team sends them from the competition. Availability depends on the event’s publication settings and connection.",
  "La vidéo est-elle disponible pour toutes les compétitions ?":
    "Is video available for every competition?",
  "Une vidéo est accessible lorsqu’un lien de diffusion a été renseigné par l’organisation pour le plateau concerné.":
    "Video is available when the organisers have provided a stream link for that platform.",
  "Pour une démonstration ou une question sur l’application.":
    "For a demo or a question about the app.",
  "Nous contacter": "Contact us",
  "Pied de page": "Footer navigation",
  Compétitions: "Competitions",
  "Informations légales": "Legal information",
  "Conditions d’utilisation": "Terms of use",
  Confidentialité: "Privacy",
  "Mentions légales": "Legal notice",
  Cookies: "Cookies",
  "Capture de l’application": "App screenshot",
  "Fermer la capture": "Close screenshot",
  "Interface de démonstration · Données fictives":
    "Demo interface · Fictional data",
  "Déplacez un groupe vers un autre plateau.":
    "Move a group to another platform.",
  Déplier: "Expand",
  "Dépliez un autre groupe pour retrouver ses athlètes.":
    "Expand another group to find its athletes.",
  Athlète: "Athlete",
  "Déplacez un athlète dans un autre groupe.":
    "Move an athlete to another group.",
  "Démonstration du planning réel": "Real scheduling workspace demo",
  "Mettre en pause le planning": "Pause the scheduling animation",
  "Lire l’animation du planning": "Play the scheduling animation",
  "Rejouer le planning": "Replay the scheduling animation",
  "Position dans l’animation du planning": "Scheduling animation position",
  "Aperçu du planning indisponible. Rechargez la page pour lire la démonstration.":
    "Scheduling preview unavailable. Reload the page to play the demo.",
  " Application réelle, données de démonstration.": " Real app, demo data.",
  "Attendez l’arbitrage de la barre annoncée à 195 kg. Le prochain essai est encore vide.":
    "Wait for the referees’ decisions on the announced 195 kg attempt. The next attempt is still blank.",
  "Les trois décisions des arbitres valident automatiquement la barre à 195 kg.":
    "The three referees’ decisions automatically validate the 195 kg lift.",
  "Survolez le badge A pour consulter les décisions des arbitres.":
    "Hover over the A badge to view the referees’ decisions.",
  "Après le passage, saisissez le prochain essai de cet athlète : 202,5 kg.":
    "After the lift, enter this athlete’s next attempt: 202.5 kg.",
  "Le troisième essai est annoncé. Le deuxième tour continue avec l’athlète suivant.":
    "The third attempt is announced. The second round continues with the next athlete.",
  "L’essai de Maël AUBERVAL à 197,5 kg est refusé automatiquement.":
    "Maël AUBERVAL’s 197.5 kg attempt is automatically recorded as a no lift.",
  "Consultez les deux décisions rouges et la décision blanche dans l’infobulle.":
    "View the two red decisions and the white decision in the tooltip.",
  "Démonstration réelle de la saisie et de l’arbitrage automatique":
    "Real attempt entry and automatic refereeing demo",
  "Mettre en pause l’arbitrage": "Pause the refereeing animation",
  "Lire l’animation de l’arbitrage": "Play the refereeing animation",
  "Rejouer l’arbitrage": "Replay the refereeing animation",
  "Position dans l’animation de l’arbitrage": "Refereeing animation position",
  "Aperçu indisponible. Rechargez la page pour lire la démonstration.":
    "Preview unavailable. Reload the page to play the demo.",
  Agrandir: "Enlarge",
  "Activer le mode sombre": "Switch to dark mode",
  "Activer le mode clair": "Switch to light mode",
  "Mode sombre": "Dark mode",
  "Mode clair": "Light mode",
  Langue: "Language",
  "Meet Manager - Gestion de compétition":
    "Meet Manager - Competition management",
  "Essai 02": "Attempt 02",
  "Éditeur de widgets": "Widget editor",
  "Athlète actuel": "Current athlete",
  Composition: "Layout",
  Calques: "Layers",
  "Votre composition": "Your layout",
  "Placez vos éléments.": "Place your elements.",
  "Créez votre style.": "Create your style.",
  "Connectez vos données.": "Connect your data.",
  "01 Composition": "01 Layout",
  "02 Style": "02 Style",
  "03 Données": "03 Data",
  "WIDGET ATHLÈTE · 800 × 180": "ATHLETE WIDGET · 800 × 180",
  "Votre widget commence ici": "Your widget starts here",
  "Source de données": "Data source",
  "Athlète actuel · Nom": "Current athlete · Name",
  Pays: "Country",
  Catégorie: "Category",
  "{Pays}": "{Country}",
  "{Catégorie}": "{Category}",
  "Votre design, connecté à la compétition":
    "Your design, connected to the competition",
  Propriétés: "Properties",
  Fond: "Background",
  Dimensions: "Dimensions",
  Typographie: "Typography",
  Couleur: "Colour",
  "Aucune source": "No source",
  "Modifications en temps réel": "Live changes",
  "Éditeur d’affichages": "Display editor",
  "Widget athlète": "Athlete widget",
  Comportement: "Behaviour",
  "✓ Enregistré": "✓ Saved",
  Éditeur: "Editor",
  "Comportement (Widget athlète)": "Behaviour (Athlete widget)",
  "Nœuds disponibles": "Available nodes",
  "Rechercher…": "Search…",
  Événements: "Events",
  "Au chargement": "On load",
  "Barre réussie": "Good lift",
  Actions: "Actions",
  "Modifier le texte": "Change text",
  "Jouer une animation": "Play an animation",
  "Couleur de fond": "Background colour",
  "Glissez les nœuds depuis la liste": "Drag nodes from the list",
  "Déposer ici": "Drop here",
  Événement: "Event",
  "Essai actuel": "Current attempt",
  "Choisir…": "Choose…",
  Cible: "Target",
  Durée: "Duration",
  "□ Lecture en boucle": "□ Loop playback",
  Action: "Action",
  Valeur: "Value",
  Performance: "Performance",
  Animation: "Animation",
  Fondu: "Fade",
  Pop: "Pop",
  Glissement: "Slide",
  Rebond: "Bounce",
  Bleu: "Blue",
  Vert: "Green",
  Corail: "Coral",
  "Choisissez une couleur": "Choose a colour",
  "Deux liens créés · Comportement prêt":
    "Two connections created · Behaviour ready",
  "0 / 3 nœuds placés": "0 / 3 nodes placed",
  "Catalogue scène": "Scene catalogue",
  Animations: "Animations",
  Objets: "Objects",
  "▣ Widget athlète": "▣ Athlete widget",
  Nom: "Name",
  "T Nom": "T Name",
  Déclencher: "Trigger",
  "DIFFUSION DE COMPÉTITION": "COMPETITION BROADCAST",
  "VOTRE WIDGET EN SURIMPRESSION": "YOUR WIDGET AS AN OVERLAY",
  "Données de démonstration": "Demo data",
  "ARBITRAGE SIMULÉ": "SIMULATED REFEREEING",
  "La vidéo n’a pas pu être lue. Relancez la lecture.":
    "The video could not be played. Try playing it again.",
  "Position dans la démonstration": "Demo position",
  "Interfaces simplifiées · Données du widget fictives ·":
    "Simplified interfaces · Fictional widget data ·",
  "Vidéo : Anthony Robledo / U.S. Navy, domaine public":
    "Video: Anthony Robledo / U.S. Navy, public domain",
  Designer: "Design",
  "Disposition, typographie, couleurs": "Layout, typography, colours",
  Connecter: "Connect",
  "Ajoutez et reliez les nœuds": "Add and connect nodes",
  Diffuser: "Broadcast",
  "Votre widget en situation": "Your widget in action",
  Entrée: "Input",
  Sortie: "Output",
  Forme: "Shape",
  Texte: "Text",
  L: "W",
  "Bleu nuit": "Navy blue",
  "Mettre en pause": "Pause",
  "Lire la démonstration": "Play the demo",
  "Rejouer la démonstration": "Replay the demo",
  Rejouer: "Replay",
  "Démonstration de l’éditeur de widgets en trois étapes":
    "Three-step widget editor demo",
  "Étapes de la démonstration": "Demo steps",
  "Étape 1 : dessinez le fond, placez les éléments, choisissez la typographie et les couleurs, puis connectez les données.":
    "Step 1: draw the background, position elements, choose fonts and colours, then connect the data.",
  "Étape 2 : ajoutez les trois nœuds depuis la liste, placez-les dans le graphe, choisissez l’animation Pop et le vert, puis reliez l’événement Barre réussie à l’animation et au changement de couleur.":
    "Step 2: add three nodes from the list, position them in the graph, choose the Pop animation and green colour, then connect the Good lift event to the animation and colour change.",
  "Étape 3 : le widget apparaît dans une diffusion de compétition simulée.":
    "Step 3: the widget appears over a simulated competition broadcast.",
  "Nom de l’athlète": "Athlete name",
  "Pays et catégorie": "Country and category",
  "Fond du widget": "Widget background",
  "Composer le libellé": "Compose the label",
  "Essai actuel · Charge": "Current attempt · Weight",
  "Choisir une source…": "Choose a source…",
  "Pays + Catégorie": "Country + Category",
  "Pays + …": "Country + …",
  "Choisir les données…": "Choose data…",
  "Partez d’un canevas vide et ajoutez le fond de votre widget.":
    "Start with a blank canvas and add your widget’s background.",
  "Étirez la forme pour dessiner les dimensions du widget.":
    "Resize the shape to set the widget’s dimensions.",
  "Choisissez un fond bleu nuit dans la palette.":
    "Choose a navy blue background from the palette.",
  "Ajoutez le nom de l’athlète et glissez-le à sa place.":
    "Add the athlete’s name and drag it into position.",
  "Agrandissez le texte et passez-le en gras.":
    "Increase the text size and make it bold.",
  "Ajoutez un libellé et glissez-le au-dessus du nom.":
    "Add a label and drag it above the name.",
  "Ajoutez le bloc de performance et glissez-le à droite.":
    "Add the performance block and drag it to the right.",
  "Choisissez le bleu pour mettre la performance en valeur.":
    "Choose blue to highlight the performance.",
  "Le design est prêt : reliez le nom à l’athlète actuel.":
    "The design is ready: bind the name to the current athlete.",
  "Reliez la performance à la charge de l’essai : 185 kg.":
    "Bind the performance to the attempt weight: 185 kg.",
  "Composez le libellé : choisissez d’abord la donnée « Pays ».":
    "Compose the label: first choose the Country field.",
  "Ajoutez « Catégorie » pour afficher « France / -83 kg ».":
    "Add Category to display “France / -83 kg”.",
  "Votre mise en page, votre typographie, vos couleurs. Passons au comportement.":
    "Your layout, your fonts, your colours. Now add the behaviour.",
  "Vert réussite · #238765": "Success green · #238765",
  "Partez d’un graphe vide et choisissez vos nœuds dans la liste.":
    "Start with an empty graph and choose nodes from the list.",
  "Glissez « Barre réussie » depuis la liste vers le graphe.":
    "Drag Good lift from the list into the graph.",
  "Ajoutez « Jouer une animation » et placez le nœud.":
    "Add Play an animation and position the node.",
  "Ajoutez ensuite l’action « Couleur de fond » depuis la liste.":
    "Then add Background colour from the list.",
  "Ouvrez le choix d’animation et sélectionnez « Pop ».":
    "Open the animation picker and select Pop.",
  "Ouvrez la palette et choisissez le vert de réussite.":
    "Open the palette and choose success green.",
  "Cliquez sur la sortie de « Barre réussie », puis sur l’entrée de l’animation.":
    "Click the Good lift output, then the animation input.",
  "Premier lien créé : l’événement déclenche l’animation Pop.":
    "First connection created: the event triggers the Pop animation.",
  "Reliez ensuite la sortie de l’animation à l’action « Couleur de fond ».":
    "Then connect the animation output to Background colour.",
  "Les deux actions sont reliées. Voyons le résultat en vidéo.":
    "Both actions are connected. Watch the result in the broadcast.",
  "Retrouvez le même widget dans votre diffusion.":
    "Use the same widget in your broadcast.",
  "Les arbitres valident l’essai…": "The referees give a good lift…",
  "Barre réussie : le widget s’anime et la performance passe au vert.":
    "Good lift: the widget animates and the performance turns green.",
};

export const showcaseFrench: Record<string, string> = Object.fromEntries(
  Object.keys(showcaseEnglish).map((key) => [key, key]),
);

export const SHOWCASE_LANGUAGE_KEY = "meet-manager.language";
export const showcaseLanguageNames: Record<AppLanguage, string> = {
  fr: "Français",
  en: "English",
};
